import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Role_PopupCSS.css'; // Adjust the path as per your file structure
import { BASE_URL } from "../../constants";


function EditPopup({ onClose ,onRowSelect }) {
    
    
    const [searchResults, setSearchResults] = useState([]);

    const [roleName, setRoleName] = useState('');
    
    // Dropdown options (you can fetch these dynamically if needed)

    // useEffect(() => {
    //     axios.get(`${ BASE_URL }/api/bookType')
    //         .then(response => setBookTypes(response.data))
    //         .catch(error => console.error('Error fetching accounts:', error));
    // }, []);

    // useEffect(() => {
    //     axios.get(`${ BASE_URL }/api/Account')
    //         .then(response => setAccountNames(response.data))
    //         .catch(error => console.error('Error fetching accounts:', error));
    // }, []);
    // useEffect(() => {
    //     axios.get(`${ BASE_URL }/api/branches')
    //         .then(response => {
    //             setBranches(response.data);
    //             // alert(response.data);
    //         })
    //         .catch(error => {
    //             console.error("There was an error fetching the data!", error);
    //         });
    // },
    //     []);

    useEffect(() => {
        searchDealer();
    }, []);

    const searchDealer = () => {
        axios.get(`${ BASE_URL }/api/get_role`, { params: { roleName } })
            .then(response => {
                setSearchResults(response.data);
            })
            .catch(error => {
                console.log('Error while fetching Role!', error);
            });
    }


    const handleSearch = async () => {
        searchDealer();
    };

    const handleSendData = async(selectedRow) => {
    
        try {
            const response = await axios.get(`${ BASE_URL }/api/get_role_by_id`, {
                params: {
                    roleId: selectedRow.role_id
                }
            });
            onRowSelect(response.data);
    
        } catch (error) {
            console.error('Error searching vouchers:', error);
        }
    };
    

    return (
        <div className="popup">
            <div className="popup-inner">
                <h5 className='header_color_search' style={{textAlign: 'left', marginLeft: '10px', marginTop: '10px'}}>Search Role Master</h5>
                <div className='d-flex justify-content-between'>
                    <div className="form-group d-flex ">
                        {/* <label className='form-label' style={{ width: '110px', marginLeft: '8px' }} >Role Name</label> */}
                        <input type="text" className="form-control me-1 mb-3" value={roleName} style={{ width: '350px', marginLeft:'20px'}}
                            onChange={(e) => setRoleName(e.target.value)} size="sm" />
                    </div>
                    <div className="d-flex justify-content-end">
                    <button className="btn btn-secondary close_btn btn-sm btn_height me-3" style={{float: 'left'}} onClick={onClose}>Close</button>
                        <button  className="btn btn-primary me-3 btn-sm btn_height" onClick={handleSearch} >Search</button>
                    </div>
                </div>

                <div className='table-container-for-Role '>
                    <table className="table mt-3 table-wrapper">
                        <thead className='table-primary'>
                            <tr>
                                <th>Role Name</th>
                                <th>Status</th>
                                <th hidden>role_id</th>
                            </tr>

                        </thead>
                        <tbody>
                            {searchResults.map((result, index) => (
                                <tr key={index} onClick={() => handleSendData(result)} style={{ cursor: 'pointer' }}>
                                    <td>{result.role_name}</td>
                                    <td>{result.role_status}</td>
                                    <td hidden>{result.role_id}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

               
            </div>
            
        </div>
    );
}

export default EditPopup;
